import { render } from "./ContributeSketch.vue?vue&type=template&id=1aea2c36&scoped=true"
import script from "./ContributeSketch.vue?vue&type=script&lang=js"
export * from "./ContributeSketch.vue?vue&type=script&lang=js"

import "./ContributeSketch.vue?vue&type=style&index=0&id=1aea2c36&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1aea2c36"

export default script